import React from "react";
import Directive from "./directive/Directive";
import Question from "./question/Question";

const View = () => {

  return (
    <div className="leaningCont">
      <div className="learning-wrap">
        <Directive />
        <Question />
      </div>
    </div>
  );

};

export default View;
